import React, { useState, useEffect } from 'react'
import { Box, Typography, Grid, Card, CardContent, Avatar, Chip, TablePagination, CircularProgress, Paper, ToggleButton, ToggleButtonGroup, IconButton, FormControl, InputLabel, Select, MenuItem, Button, Alert } from "@mui/material";
import { Link } from "react-router-dom";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import PhoneIcon from '@mui/icons-material/Phone'
import EmailIcon from '@mui/icons-material/Email'
import TelegramIcon from '@mui/icons-material/Telegram'
import StarIcon from '@mui/icons-material/Star'
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import CallMadeIcon from '@mui/icons-material/CallMade'
import RouterIcon from '@mui/icons-material/Router'
import DnsIcon from '@mui/icons-material/Dns'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from '@mui/icons-material/Info';
import Loader from "../Loader";
import PersonIcon from '@mui/icons-material/Person';
import { graphics, input, sip, short, did } from "../../translate";
import Utils from "../../Utils";
import Cookies from "js-cookie";
import { activitiesStyles, employeeTableStyles, greenTheme } from "../../helpers/style";
import AssignedSearch from "./AssignedSearch";
import { useSelector } from "react-redux";
const { REACT_APP_SERVER } = process.env;
let color = REACT_APP_SERVER === 'ATS' ? '#0b73b9' : greenTheme.primary
const primaryColor = REACT_APP_SERVER === 'ATS' ? '#0b73b9' : greenTheme.primary;
const hoverColor = REACT_APP_SERVER === 'ATS' ? '#095a8f' : greenTheme.hover;

export default function EmployeeTable({
    data = [],
    loading = false,
    onEdit = () => { },
    onDelete = () => { },
    onAdd = () => { },
    title = '',
    viewMode = 'table',
    onViewModeChange = () => { }
}) {
    const langIndex = +localStorage.getItem('atsLang') || 1
    const [searchQuery, setSearchQuery] = useState('')
    const [sortBy, setSortBy] = useState(null)
    const profile = useSelector(state => state.users.ursData)
    const profileEmpty = !profile || Object.keys(profile).length === 0
    const [sortOrder, setSortOrder] = useState(null)
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(Cookies.get("sip") ? parseInt(Cookies.get("sip")) : 10)
    const [copied, setCopied] = useState(false)
    const [chipFilter, setChipFilter] = useState('all') // 'all' | 'sip' | 'tec' | 'mob' | 'crm' | 'msg' | 'speech' | 'webrtc'
    const employeeData = useSelector(state => state.users.employeeData)
    const permissions = employeeData?.permission? JSON.parse(employeeData.permission.permissions_json) : []
    const hasPermission = employeeData?.permission == null
    const canAdd = hasPermission || permissions.includes('employees_create')
    const canEdit = hasPermission || permissions.includes('employees_edit')
    const activeChipSx = {
        backgroundColor: primaryColor,
        color: '#fff',
        borderColor: primaryColor,
    }
    const adminChipBaseSx = {
        borderColor: primaryColor,
        color: primaryColor,
        fontWeight: 500,
    }
    const titleArr = [
        sip.phone[langIndex],
        sip.out[langIndex],
        sip.forward[langIndex],
        sip.note[langIndex],
        sip.outgoing[langIndex],
        sip.rec[langIndex],
        sip.crm[langIndex],
        sip.short[langIndex],
        "Telegram",
        "Rate",
        "Speech",
    ]

    let descArr = []

    const handleSearchChange = (value) => {
        setSearchQuery(value)
    }

    const handleSort = (column) => {
        if (sortBy === column) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
        } else {
            setSortBy(column)
            setSortOrder('asc')
        }
    }

    const uniqueData = data.filter((item, index, self) =>
        index === self.findIndex(i => (i.buddy && i.buddy === item.buddy) || (i.id && i.id === item.id))
    )

    const filteredData = searchQuery
        ? uniqueData.filter(item => {
            const query = searchQuery.toLowerCase()
            const searchableFields = [
                item.buddy,
                item.notes,
                item.email,
                item.redirect_output,
                item.telegram_phone,
                item.sip_ip,
                item.short,
            ]
            return searchableFields.some(field =>
                field !== null &&
                field !== undefined &&
                String(field).toLowerCase().includes(query)
            )
        })
        : uniqueData

    const matchesChipFilter = (s) => {
        switch (chipFilter) {
            case 'sip':
                return !!s?.issip
            case 'tec':
                return !s?.issip && (!s?.redirect_output || (s?.redirect_output?.length ?? 0) < 8 || String(s?.redirect_output ?? '').includes('_'))
            case 'mob':
                return (s?.redirect_output?.length ?? 0) >= 8 && !String(s?.redirect_output ?? '').includes('_')
            case 'crm':
                return !!(s?.crm || s?.crm_id)
            case 'msg':
                return !!(s?.telegram || s?.telegram_phone)
            case 'speech':
                return !!s?.isspeech
            case 'webrtc':
                return !!s?.isweb
            default:
                return true
        }
    }

    const chipFilteredData = filteredData.filter(matchesChipFilter)

    const sortedData = [...chipFilteredData].sort((a, b) => {
        if (!sortBy) return 0

        let aValue, bValue

        switch (sortBy) {
            case 'buddy':
                aValue = (a.buddy || '').toString().toLowerCase()
                bValue = (b.buddy || '').toString().toLowerCase()
                break
            case 'notes':
                aValue = (a.notes || '').toString().toLowerCase()
                bValue = (b.notes || '').toString().toLowerCase()
                break
            case 'sipdid':
                aValue = (a.sipdid || '').toString().toLowerCase()
                bValue = (b.sipdid || '').toString().toLowerCase()
                break
            case 'redirects':
                aValue = (a.redirect_output || '').toString().toLowerCase()
                bValue = (b.redirect_output || '').toString().toLowerCase()
                break
            case 'codelist':
                aValue = (a.codelist || '').toString().toLowerCase()
                bValue = (b.codelist || '').toString().toLowerCase()
                break
            case 'rec':
                aValue = +a.rec || 0
                bValue = +b.rec || 0
                break
            case 'crm':
                aValue = (a.crm_id || a.crm_type) ? 'C' : ''
                bValue = (b.crm_id || b.crm_type) ? 'C' : ''
                break
            case 'msg':
                aValue = a.telegram_phone ? 'T' : ''
                bValue = b.telegram_phone ? 'T' : ''
                break
            case 'rating':
                aValue = +a.rating || 0
                bValue = +b.rating || 0
                break
            case 'email':
                aValue = (a.email || '').toString().toLowerCase()
                bValue = (b.email || '').toString().toLowerCase()
                break
            case 'short':
                aValue = +(a.short || '') || 0
                bValue = +(b.short || '') || 0
                break
            default:
                return 0
        }

        if (sortOrder === 'asc') {
            if (typeof aValue === 'number' && typeof bValue === 'number') {
                return aValue - bValue
            }
            return aValue > bValue ? 1 : aValue < bValue ? -1 : 0
        } else {
            if (typeof aValue === 'number' && typeof bValue === 'number') {
                return bValue - aValue
            }
            return aValue < bValue ? 1 : aValue > bValue ? -1 : 0
        }
    })

    descArr = sortedData.map(s => ({
        number: s?.buddy || '',
        out: s?.sipdid || '',
        redirect: s?.redirect_output || '',
        notes: s?.notes || '',
        line: s?.codelist || '',
        rec: s?.rec || '',
        crm: s?.crm_id || s?.crm_type ? 'C' : '',
        short: s?.short || '',
        telegram: s?.telegram?.account_id ? 'T' : '',
        rate: s?.rate ? +s?.rating : '',
        speech: s?.isspeech ? 'Y' : ''
    }))

    // Paginate data
    const paginatedData = rowsPerPage > 0
        ? sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        : sortedData

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10)
        setRowsPerPage(newRowsPerPage)
        setPage(0)
        Cookies.set("sip", newRowsPerPage, { expires: 30 })
    }


    return (
        <div className="tableParent" id="tableParent">
            <Paper sx={{ p: 3, boxShadow: 3 }}>
                <Box sx={employeeTableStyles.headerBox}>
                    <Box sx={{ ...employeeTableStyles.headerTitleBox, width: '100%', justifyContent: 'space-between' }}>
                        <Typography sx={employeeTableStyles.title} variant="h5" component="h1">{title}</Typography>
                       {!employeeData?.buddy && !profileEmpty ? <Button
                            component={Link}
                            to="/employees/upload"
                            variant="outlined"
                            size="small"
                            startIcon={<UploadFileIcon />}
                            sx={{
                                textTransform: 'none',
                                borderColor: primaryColor,
                                color: primaryColor,
                                '&:hover': {
                                    borderColor: hoverColor,
                                    backgroundColor: `${primaryColor}10`,
                                },
                            }}
                        >
                            {langIndex === 1 ? 'Upload Employees' : langIndex === 2 ? 'Загрузить сотрудников' : 'Վերբեռնել աշխատակիցներ'}
                        </Button>:null}
                    </Box>
                    {/* <ToggleButtonGroup
                        value={viewMode}
                        exclusive
                        onChange={onViewModeChange}
                        aria-label="view mode"
                        size="small"
                    >
                        <ToggleButton value="table" aria-label="table view">
                            <ViewListIcon />
                        </ToggleButton>
                        <ToggleButton value="card" aria-label="card view">
                            <ViewModuleIcon />
                        </ToggleButton>
                    </ToggleButtonGroup> */}
                </Box>
                <Box sx={employeeTableStyles.searchSortContainer}>
                    <Box sx={employeeTableStyles.searchBox}>
                        <AssignedSearch
                            value={searchQuery}
                            onChange={handleSearchChange}
                            onAdd={canAdd ? onAdd : undefined}
                            addColor={primaryColor}
                            placeholder={input.search[langIndex]}
                            showAdd={true}
                        />
                    </Box>
                    <Box sx={employeeTableStyles.sortContainer}>
                        <FormControl
                            size="small"
                            sx={{
                                ...employeeTableStyles.sortFormControl,
                                '& .MuiInputLabel-root.Mui-focused': { color: primaryColor },
                            }}
                        >
                            <InputLabel>{input.sortBy[langIndex]}</InputLabel>
                            <Select
                                value={sortBy || ''}
                                label={input.sortBy[langIndex]}
                                onChange={(e) => {
                                    if (e.target.value) {
                                        handleSort(e.target.value)
                                    } else {
                                        setSortBy(null)
                                        setSortOrder(null)
                                    }
                                }}
                                sx={{
                                    ...employeeTableStyles.sortSelect,
                                    '& .MuiOutlinedInput-notchedOutline': { borderColor: primaryColor },
                                    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: hoverColor },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: primaryColor },
                                }}
                            >
                                <MenuItem value="">
                                    <em>{input.none[langIndex]}</em>
                                </MenuItem>
                                <MenuItem value="redirects">{sip.phone[langIndex]}</MenuItem>
                                <MenuItem value="notes">{input.name[langIndex]}</MenuItem>
                                <MenuItem value="sipdid">{sip.out[langIndex]}</MenuItem>
                                <MenuItem value="rec">{sip.rec[langIndex]}</MenuItem>
                                <MenuItem value="rating">{graphics.rate[langIndex]}</MenuItem>
                                <MenuItem value="email">{input.email[langIndex]}</MenuItem>
                                <MenuItem value="short">{short.private[langIndex]}</MenuItem>
                            </Select>
                        </FormControl>
                        {sortBy && (
                            <IconButton
                                size="small"
                                onClick={() => handleSort(sortBy)}
                                sx={employeeTableStyles.getSortIconButton(color)}
                                aria-label={sortOrder === 'asc' ? input.sortDesc[langIndex] : input.sortAsc[langIndex]}
                            >
                                {sortOrder === 'asc' ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
                            </IconButton>
                        )}
                    </Box>
                </Box>

                {loading ? (
                    <Box sx={employeeTableStyles.loadingBox}>
                        <CircularProgress sx={{ color }} />
                    </Box>
                ) : (
                    <>
                        <Box sx={{ mb: 2 }}>
                            <ToggleButtonGroup
                                value={chipFilter}
                                exclusive
                                onChange={(e, value) => { if (value != null) setChipFilter(value); setPage(0) }}
                                size="medium"
                                sx={{
                                    flexWrap: 'wrap',
                                    '& .MuiToggleButton-root': {
                                        textTransform: 'none',
                                        py: 1,
                                        px: 2,
                                        fontSize: '0.95rem',
                                        color: 'text.secondary',
                                        borderColor: 'divider',
                                    },
                                    '& .MuiToggleButton-root.Mui-selected': { backgroundColor: primaryColor, color: '#fff', borderColor: primaryColor, '&:hover': { backgroundColor: hoverColor } },
                                }}
                            >
                                <ToggleButton value="all" aria-label="all">
                                    {did.all?.[langIndex] ?? 'All'}
                                </ToggleButton>
                                <ToggleButton value="sip" aria-label="sip">SIP</ToggleButton>
                                <ToggleButton value="tec" aria-label="tec">TEC</ToggleButton>
                                <ToggleButton value="mob" aria-label="mob">MOB</ToggleButton>
                                <ToggleButton value="crm" aria-label="crm">CRM</ToggleButton>
                                <ToggleButton value="msg" aria-label="msg">MSG</ToggleButton>
                                <ToggleButton value="speech" aria-label="speech">Speech</ToggleButton>
                                <ToggleButton value="webrtc" aria-label="webrtc">WebRTC</ToggleButton>
                            </ToggleButtonGroup>
                        </Box>
                        {chipFilter !== 'all' && (
                            <Alert
                                icon={<InfoIcon />}
                                severity="success"
                                sx={
                                    REACT_APP_SERVER !== 'ATS'
                                        ? { mb: 3 }
                                        : {
                                            mb: 3,
                                            border: '1px solid',
                                            borderColor: primaryColor,
                                            backgroundColor: `${primaryColor}10`,
                                            '& .MuiAlert-icon': { color: primaryColor },
                                        }
                                }
                            >
                                <Typography variant="body2">
                                    {chipFilter === 'sip' && (langIndex === 1 ? 'Employees who have a SIP number assigned and are authorized to use SIP client applications (MicroSIP, Zoiper, Grandstream, etc.) to make and receive calls are displayed.' : langIndex === 2 ? 'Отображаются сотрудники, которым присвоен SIP-номер и которые имеют право использовать клиентские SIP-приложения (MicroSIP, Zoiper, Grandstream и т. д.) для совершения и приема звонков.' : 'Ցուցադրվում են այն աշխատակիցները, ովքեր ունեն տրամադրված SIP համար և իրավասու են օգտագործել SIP client ծրագրեր (MicroSIP, Zoiper, Grandstream և այլն) զանգեր կատարելու և ընդունելու համար։')}
                                    {chipFilter === 'mob' && (langIndex === 1 ? 'Employees who have a corporate number and can receive calls on their mobile device are displayed.' : langIndex === 2 ? 'Отображаются сотрудники, имеющие корпоративный номер телефона и способные принимать звонки на свои мобильные устройства.' : 'Ցուցադրվում են այն աշխատակիցները, ովքեր ունեն կորպորատիվ համար և կարող են զանգեր ընդունել իրենց բջջային սարքով։')}
                                    {chipFilter === 'tec' && (langIndex === 1 ? 'Showing employees with mobile redirect number.' : langIndex === 2 ? 'Показаны сотрудники с мобильным номером перенаправления.' : 'Ցուցադրվում են բջջային վերահասցեավորում ունեցող աշխատակիցները։')}
                                    {chipFilter === 'crm' && (langIndex === 1 ? 'Showing employees with CRM integration.' : langIndex === 2 ? 'Показаны сотрудники с интеграцией CRM.' : 'Ցուցադրվում են CRM ինտեգրում ունեցող աշխատակիցները։')}
                                    {chipFilter === 'msg' && (langIndex === 1 ? 'Employees who are authorized to make internal and external calls through their Telegram app using the organization"s main number are displayed.' : langIndex === 2 ? 'Отображаются сотрудники, уполномоченные совершать внутренние и внешние звонки через приложение Telegram, используя основной номер организации.' : 'Ցուցադրվում են այն աշխատակիցները, ովքեր իրավասու են իրենց Telegram հավելվածի միջոցով կատարել ներքին և արտաքին զանգեր՝ կազմակերպության գլխավոր համարի միջոցով։')}
                                    {chipFilter === 'speech' && (langIndex === 1 ? 'Only employees who have the Voice to Text feature activated and can automatically convert recordings to text on their personal page are displayed.' : langIndex === 2 ? 'Отображаются те сотрудники, у которых активирована функция преобразования голоса в текст и которые могут автоматически конвертировать записи в текст на своей личной странице.' : 'Ցուցադրվում են այն աշխատակիցները, ովքեր ակտիվացված Ձայնից Տեքստ հնարավորությամբ կարող են իրենց անձնական էջում ձայնագրությունները ավտոմատ վերածել տեքստի։')}
                                    {chipFilter === 'webrtc' && (langIndex === 1 ? 'Employees who have active WebRTC capabilities and can make and receive calls from their personal page are displayed.' : langIndex === 2 ? 'Отображаются сотрудники, у которых активирована функция WebRTC и которые могут совершать и принимать звонки со своей личной страницы.' : 'Ցուցադրվում են այն աշխատակիցները, ովքեր ունեն ակտիվ WebRTC հնարավորություն և կարող են իրենց անձնական էջից կատարել և ընդունել զանգեր։')}
                                </Typography>
                            </Alert>
                        )}
                        {paginatedData.length ? (
                            <>
                                <Box sx={activitiesStyles.activitiesContainer}>
                            {paginatedData.map((s, index) => {
                                const isActive = REACT_APP_SERVER === 'Beeline'
                                    ? (s?.sip_buddy?.regseconds > 0 && s?.sip_buddy?.port > 0)
                                    : (s?.ipaddr || s?.sip_ip)

  return (
                                    <Card
                                        key={`${s.buddy || s.id || 'emp'}-${index}`}
                                        sx={{
                                            ...activitiesStyles.activityCard,
                                            '&:hover': {
                                                boxShadow: `0 8px 24px ${primaryColor}25`,
                                                borderColor: primaryColor,
                                            },
                                        }}
                                    >
                                        <CardContent sx={activitiesStyles.cardContent}>
                                            <Box sx={activitiesStyles.cardContentBox}>
                                                <Avatar
                                                    sx={{
                                                        ...activitiesStyles.getActivityAvatar(isActive),
                                                        bgcolor: isActive ? primaryColor : '#9e9e9e',
                                                        boxShadow: isActive ? `0 4px 12px ${primaryColor}50` : undefined,
                                                    }}
                                                >
                                                    {(s?.notes || s?.buddy)?.[0]?.toUpperCase() || 'E'}
                                                </Avatar>

                                                <Box sx={activitiesStyles.activityContentBox}>
                                                    <Box sx={activitiesStyles.chipsContainer}>
                                                        <Chip
                                                            label={
                                                                s?.issip
                                                                    ? 'SIP'
                                                                    : !s?.redirect_output || (s?.redirect_output?.length ?? 0) < 8 || String(s?.redirect_output ?? '').includes('_')
                                                                        ? 'TEC'
                                                                        : 'MOB'
                                                            }
                                                            size="small"
                                                            variant="outlined"
                                                            sx={{
                                                                ...activitiesStyles.methodChip,
                                                                ...activeChipSx,
                                                            }}
                                                        />
                                                        {s.issip && s?.redirect_output && s?.redirect_output?.length >= 8 && !s?.redirect_output?.includes('_') ?
                                                            <Chip
                                                                label={
                                                                    'MOB'
                                                                }
                                                                size="small"
                                                                variant="outlined"
                                                                sx={{
                                                                    ...activitiesStyles.methodChip,
                                                                    ...activeChipSx,
                                                                }}
                                                            />
                                                            : null}
                                                        <Chip
                                                            label="CRM"
                                                            size="small"
                                                            variant="outlined"
                                                            sx={{
                                                                ...adminChipBaseSx,
                                                                ...(s?.crm || s?.crm_id ? activeChipSx : activitiesStyles.chipInactive),
                                                            }}
                                                        />
                                                        <Chip
                                                            label="MSG"
                                                            size="small"
                                                            variant="outlined"
                                                            sx={{
                                                                ...adminChipBaseSx,
                                                                ...(s?.telegram || s?.telegram_phone ? activeChipSx : activitiesStyles.chipInactive),
                                                            }}
                                                        />
                                                        <Chip
                                                            label="Speech"
                                                            size="small"
                                                            variant="outlined"
                                                            sx={{
                                                                ...adminChipBaseSx,
                                                                ...(s?.isspeech ? activeChipSx : activitiesStyles.chipInactive),
                                                            }}
                                                        />
                                                    </Box>

                                                    <Typography variant="h6" sx={activitiesStyles.activityTitle}>
                                                        {s?.notes || s?.buddy}
                                                    </Typography>

                                                    <Box sx={activitiesStyles.metadataBox}>
                                                        {s?.buddy ? (
                                                            <Box sx={activitiesStyles.metadataItem}>
                                                                <PhoneIcon fontSize="small" sx={{ ...activitiesStyles.metadataIcon, mr: 0.5, color: primaryColor }} />
                                                                <Typography variant="caption" sx={activitiesStyles.metadataText}>
                                                                    <strong>{sip.phone[langIndex]}:</strong> {s?.redirect_output && s?.redirect_output?.length >= 8 && !s?.redirect_output?.includes('_') ? s.redirect_output.length === 8 ? `0${s.redirect_output}` : s.redirect_output : s.buddy}
                                                                </Typography>
                                                            </Box>
                                                        ) : null}
                                                        {s?.sipdid ? (
                                                            <Box sx={activitiesStyles.metadataItem}>
                                                                <CallMadeIcon fontSize="small" sx={{ ...activitiesStyles.metadataIcon, mr: 0.5, color: primaryColor }} />
                                                                <Typography variant="caption" sx={activitiesStyles.metadataText}>
                                                                    <strong>{sip.out[langIndex]}:</strong> {s.sipdid}
                                                                </Typography>
                                                            </Box>
                                                        ) : null}

                                                        {s?.codetypeResult?.length > 0 ? (
                                                            <Box sx={activitiesStyles.metadataItem}>
                                                                <DnsIcon fontSize="small" sx={{ ...activitiesStyles.metadataIcon, mr: 0.5, color: primaryColor }} />
                                                                <Typography variant="caption" sx={activitiesStyles.metadataText}>
                                                                    <strong>{sip.outgoing[langIndex]}:</strong> {s.codetypeResult.map(m => m.later).join(', ')}
                                                                </Typography>
                                                            </Box>
                                                        ) : null}
                                                        {s?.rec ? (
                                                            <Box sx={activitiesStyles.metadataItem}>
                                                                <GraphicEqIcon fontSize="small" sx={{ ...activitiesStyles.metadataIcon, mr: 0.5, color: primaryColor }} />
                                                                <Typography variant="caption" sx={activitiesStyles.metadataText}>
                                                                    <strong>{sip.rec[langIndex]}:</strong> R{s.rec}
                                                                </Typography>
                                                            </Box>
                                                        ) : null}
                                                        {s?.rating ? (
                                                            <Box sx={activitiesStyles.metadataItem}>
                                                                <StarIcon fontSize="small" sx={{ ...activitiesStyles.metadataIcon, mr: 0.5, color: '#ffa726' }} />
                                                                <Typography variant="caption" sx={activitiesStyles.metadataText}>
                                                                    <strong>{graphics['rate'][langIndex]}:</strong> {s.rating != null && !isNaN(Number(s.rating)) ? (Math.floor(Number(s.rating) * 10) / 10) : (s.rating ?? '')}
                                                                </Typography>
                                                            </Box>
                                                        ) : null}
                                                        {s?.email ? (
                                                            <Box sx={activitiesStyles.metadataItem}>
                                                                <EmailIcon fontSize="small" sx={{ ...activitiesStyles.metadataIcon, mr: 0.5, color: primaryColor }} />
                                                                <Typography variant="caption" sx={activitiesStyles.metadataText}>
                                                                    <strong>Email:</strong> {s.email}
                                                                </Typography>
                                                            </Box>
                                                        ) : null}
                                                        {s?.telegram_phone ? (
                                                            <Box sx={activitiesStyles.metadataItem}>
                                                                <TelegramIcon fontSize="small" sx={{ ...activitiesStyles.metadataIcon, mr: 0.5, color: '#0088cc' }} />
                                                                <Typography variant="caption" sx={activitiesStyles.metadataText}>
                                                                    <strong>Telegram:</strong> {s.telegram_phone}
                                                                </Typography>
                                                            </Box>
                                                        ) : null}
                                                        {s?.short ? (
                                                            <Box sx={activitiesStyles.metadataItem}>
                                                                <PersonIcon fontSize="small" sx={{ ...activitiesStyles.metadataIcon, mr: 0.5, color: primaryColor }} />
                                                                <Typography variant="caption" sx={activitiesStyles.metadataText}>
                                                                    <strong>{short.private[langIndex]}:</strong> {s.short}
                                                                </Typography>
                                                            </Box>
                                                        ) : null}
                                                    </Box>
                                                </Box>

                                                <Box sx={{...employeeTableStyles.actionsContainer, minHeight: '130px'}}>

                                                    <Box sx={{ ...employeeTableStyles.actionButtonsBox, marginBottom: "27px" }}>
                                                        {canEdit && (
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => onEdit(s?.buddy || s?.id)}
                                                            sx={{
                                                                color: primaryColor,
                                                                '&:hover': {
                                                                    backgroundColor: `${primaryColor}1a`,
                                                                    transform: 'scale(1.1)',
                                                                },
                                                                transition: 'all 0.2s ease',
                                                                padding: '6px',
                                                            }}
                                                            aria-label="Edit"
                                                        >
                                                            <FontAwesomeIcon icon={faPenToSquare} />
                                                        </IconButton>
                                                        )}
                                                        {employeeData?.buddy? null : <IconButton
                                                            size="small"
                                                            onClick={() => onDelete(s?.buddy || s?.id)}
                                                            sx={employeeTableStyles.deleteIconButton}
                                                            aria-label="Delete"
                                                        >
                                                            <FontAwesomeIcon icon={faTrashCan} />
                                                        </IconButton>}
                                                    </Box>
                                                    {isActive && (
                                                        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                                            <CheckCircleIcon sx={employeeTableStyles.activeIcon(color)} />
                                                            <Typography
                                                                onClick={() => {
                                                                    if (s?.buddy && s?.secret) {
                                                                        alert(`${s.buddy} ${s.secret}`)
                                                                    }
                                                                }}
                                                                variant="caption"
                                                                sx={{
                                                                    ...employeeTableStyles.getIpAddressText(color, s?.buddy && s?.secret),
                                                                    color: s?.oprec !== 2 && s?.oprec !== 0 ? color : '#9e9e9e',
                                                                    maxWidth: '90px',
                                                                }}
                                                            >
                                                                {s?.sip_buddy?.ipaddr || s?.ipaddr || s?.sip_ip}
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                </Box>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                )
                            })}
                                </Box>
                                <Box sx={employeeTableStyles.footerBox}>
                                    <Box className="footer-chip-box" sx={employeeTableStyles.footerLinksBox}>
                                        <Chip label="EXCEL" variant="outlined" size="small" onClick={() => Utils.dataToExel(titleArr, descArr)} sx={{ cursor: 'pointer', borderRadius: '7px', padding: '4px', fontSize: 11, borderColor: primaryColor, color: primaryColor, '& .MuiChip-label': { fontSize: 11 }, '&:hover': { backgroundColor: primaryColor, color: '#fff', borderColor: primaryColor } }} />
                                        <Chip label="CSV" variant="outlined" size="small" onClick={() => Utils.dataToExel(titleArr, descArr)} sx={{ cursor: 'pointer', borderRadius: '7px', padding: '4px', fontSize: 11, borderColor: primaryColor, color: primaryColor, '& .MuiChip-label': { fontSize: 11 }, '&:hover': { backgroundColor: primaryColor, color: '#fff', borderColor: primaryColor } }} />
                                        <Chip label="PRINT" variant="outlined" size="small" onClick={() => window.print()} sx={{ cursor: 'pointer', borderRadius: '7px', padding: '4px', fontSize: 11, borderColor: primaryColor, color: primaryColor, '& .MuiChip-label': { fontSize: 11 }, '&:hover': { backgroundColor: primaryColor, color: '#fff', borderColor: primaryColor } }} />
                                        <Chip label="COPY" variant="outlined" size="small" onClick={() => Utils.copy(setCopied)} sx={{ cursor: 'pointer', borderRadius: '7px', padding: '4px', fontSize: 11, borderColor: primaryColor, color: primaryColor, '& .MuiChip-label': { fontSize: 11 }, '&:hover': { backgroundColor: primaryColor, color: '#fff', borderColor: primaryColor } }} />
                                    </Box>
                                    <TablePagination
                                        rowsPerPageOptions={[10, 25, 100, { label: did.all[langIndex], value: -1 }]}
                                        component="div"
                                        count={sortedData.length}
                                        labelRowsPerPage={input.rowsPerPage[langIndex]}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </Box>
                            </>
                        ) : (
                            <Box sx={employeeTableStyles.emptyStateBox}>
                                <Typography variant="body1" color="text.secondary">
                                    {sip.no_found[langIndex]}
                                </Typography>
                            </Box>
                        )}
                    </>
                )}
            </Paper>
            {copied ? <div className="copied">Copied</div> : null}
        </div>
  )
}
